import { type ReactNode, useLayoutEffect, useRef, useState } from "react";
import {
	AppHeaderSlotsContext,
	createAppHeaderSlotsStore,
	useAppHeaderSlotsStore,
} from "./app-header-slots-state";

export function AppHeaderSlotsProvider({ children }: { children: ReactNode }) {
	const [store] = useState(createAppHeaderSlotsStore);
	return (
		<AppHeaderSlotsContext.Provider value={store}>
			{children}
		</AppHeaderSlotsContext.Provider>
	);
}

/**
 * Declares the current page's center dock content. Rendering the component
 * without children intentionally clears the fallback center navigation.
 */
export function AppHeaderCenterSlot({ children }: { children?: ReactNode }) {
	const store = useAppHeaderSlotsStore();
	const ownerRef = useRef<symbol | null>(null);
	if (ownerRef.current === null) {
		// oxlint-disable-next-line react-doctor/no-ref-current-in-render
		ownerRef.current = Symbol("app-header-center-slot");
	}

	useLayoutEffect(
		() => store.registerCenter(ownerRef.current!, children ?? null),
		[children, store],
	);

	return null;
}
